module.exports = __webpack_public_path__ + "img/fa-brands-400.363e840.svg";